import { openModalByName } from '@mindtickle/modal/withModal';
import {
  getModuleFromInitalisedRemote,
  isRemoteIntialised,
} from '@mindtickle/ui-shell-core/DynamicRemote';

import { NavigateFunction } from 'react-router';
import { UserInfo } from '~/components/GlobalHeader/Shared/type';
import { DYNAMIC_REMOTES } from '~/config/app.constants';

import { MixpanelTrackType } from '../../../type';
import { MixpanelEventNameType } from '../type';

export const trackAndHideAction = ({
  track,
  onHideDropdownContent,
}: {
  track: MixpanelTrackType<MixpanelEventNameType>;
  onHideDropdownContent: () => void;
}) => (eventName: MixpanelEventNameType) => {
  onHideDropdownContent();
  track(eventName);
};

export const openUrl = (url: string) => () => window.open(url);

export const openSupportModal = ({ navigate }: { navigate: NavigateFunction }) => async () => {
  if (!isRemoteIntialised(DYNAMIC_REMOTES.GET_SUPPORT.remoteName)) return;
  const { remoteName, moduleName } = DYNAMIC_REMOTES.GET_SUPPORT;
  const { MODAL_NAME } = await getModuleFromInitalisedRemote(remoteName, moduleName);
  openModalByName(MODAL_NAME, navigate, { stacking: true });
};

export const openChatSupport = ({
  berryActions,
  user,
  isBerryChatDisabledForAdmin,
}: {
  berryActions: any;
  user: UserInfo;
  isBerryChatDisabledForAdmin: boolean;
}) => () => {
  if (
    !isBerryChatDisabledForAdmin &&
    berryActions?.isBerryInitialized() &&
    !window?.fcWidget?.showFreshchatFirst
  ) {
    berryActions?.toggleBerrychat({ hideButton: false, hideChatbox: false });
  } else {
    window.fcWidget && window.fcWidget.open();
    window.Berry?.setToggleVisibility(false);
    window.Berry?.hide();
  }
};
